import axios from "axios";
import { Apis } from "constants/apis";
import { IUninstallFeedbackPayload } from "types/services";

const uninstallFeedback = async (payload: IUninstallFeedbackPayload) => {
    const { data } = await axios.post(Apis.EXTENSION_UNINSTALL_FEEDBACK, payload);
    return data
}

export default uninstallFeedback;